// Comercial — vista principal del dashboard comercial.
// Usa CommercialDashboard (componente) que carga datos vía /api/comercial.
import CommercialDashboard from '../components/CommercialDashboard'

export default function Comercial() {
  return <CommercialDashboard />
}
